import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import {
  FilterMenuElement,
  FilterMenuElementItem,
} from '../filter-menu-element/filter-menu-element';
import { FilterService } from '../../../services/filters.service';
import { FilterSortDirection, FilterSortMode } from '../../../types/filter.type';

const SORT_DIRECTION_ELEMENTS: Record<FilterSortMode, FilterMenuElementItem[]> = {
  alphabetic: [
    {
      id: 'asc',
      icon: 'sort_arrow_top',
      name: 'table.sort.alphabetic.asc',
    },
    {
      id: 'desc',
      icon: 'sort_arrow_bottom',
      name: 'table.sort.alphabetic.desc',
    },
  ],
  numeric: [
    {
      id: 'asc',
      icon: 'sort_arrow_top',
      name: 'table.sort.numeric.asc',
    },
    {
      id: 'desc',
      icon: 'sort_arrow_bottom',
      name: 'table.sort.numeric.desc',
    },
  ],
};

@Component({
  selector: 'app-sort-direction-menu-element',
  imports: [FilterMenuElement],
  template: `<ul
    app-filter-menu-element
    [elements]="sortDirectionElements()"
    [activeElementId]="activeSortDirection()"
    (onElementClick)="setFilterSortDirection($event)"
  ></ul>`,
  styleUrl: './sort-direction-menu-element.scss',
})
export class SortDirectionMenuElement {
  readonly filterService: FilterService = inject(FilterService);

  column: InputSignal<string> = input.required<string>();
  activeSortDirection: Signal<FilterSortDirection | undefined> = computed(() =>
    this.filterService.getActiveSortDirection(this.column()),
  );

  sortMode: Signal<FilterSortMode> = computed(
    () => this.filterService.filter()[this.column()]?.sortMode ?? 'numeric',
  );
  sortDirectionElements: Signal<FilterMenuElementItem[]> = computed(
    () => SORT_DIRECTION_ELEMENTS[this.sortMode()],
  );

  setFilterSortDirection(sortDirection: string): void {
    this.filterService.setFilterSortDirection(this.column(), sortDirection as FilterSortDirection);
  }
}
